window.themeObj = {
  tools: {
    price: function(price) {
      var newPrice = '$' + parseFloat(price).toFixed(2);
      return newPrice;
    }
  },
  init: function() {
    window.themeObj.templates.init();
  },
  templates: {
    init: function() {
      window.themeObj.templates.cms.init();
    },
    cms: {
      data: {
        wrapper: $('#cms__snize_wrapper'),
        host: $('#cms__snize_wrapper').attr('data-host'),
        uri: $('#cms__snize_wrapper').attr('data-cms-query'),
        response: {}
      },
      init: function() {

        $(window).resize(function() {
          var results = $('#cms__snize_results');

          if (!results.length) {
            results = $('#snize_results');
          }
          
          if ($(window).width() < 1025) {
            results.addClass('snize-mobile-design').addClass('snize-new-version');
            
          } else {
            results.removeClass('snize-mobile-design').removeClass('snize-new-version');
          }
        });
        
        window.themeObj.templates.cms.refresh();

        setInterval(function() {
          window.themeObj.templates.cms.refresh();
        }, 1000);

        // $('h1.collection__title').append('...');
      },
      loaded: 0,
      lastClickTime: 0,
      refreshInterval: null,
      refresh: function() {
        const loaded = $('#cms__snize-loaded');

        if (!loaded.length) {
          
          if (window.themeObj.templates.cms.data.response.items) {
            window.themeObj.templates.cms.refreshContent();
          
          } else {
          
            $.ajax({
              type: 'GET', 
              url: window.themeObj.templates.cms.getApiLink(),
              dataType: 'json',
              success: function (response) {
                window.themeObj.templates.cms.loaded++;
  
                if (response.items) {
                  window.themeObj.templates.cms.data.response = response;
                  window.themeObj.templates.cms.refreshContent();
                }
              }
            });
          }
        }
      },
      refreshContent: function() {
        const response = window.themeObj.templates.cms.data.response;

        if (!response.items) {
          console.error('CMS refreshContent', 'response empty');
          return;
        }
        
        const results = $('#snize_results');
        
        window.themeObj.templates.cms.sorting();
        window.themeObj.templates.cms.filters();
        window.themeObj.templates.cms.products();
        window.themeObj.templates.cms.pagination.init();
        
        const loadingResults = $('.snize-products__loading');

        window.themeObj.templates.cms.data.wrapper.addClass('is-active');
        loadingResults.hide();

        if ($(window).width() < 1025) {
          results.addClass('snize-mobile-design').addClass('snize-new-version');
        }
        
        results.show();
      },
      getApiLink: function(cmsQuery) {
        console.log('queries', window.themeObj.templates.cms.data.uri);
        const queries = window.themeObj.templates.cms.data.uri.split('?')[1].split('&');
        
        var url = 'https://searchserverapi.com/getresults?api_key=4V0W1G4B9n';

        for (var i = 0; i < queries.length; i++) {
          const query = queries[i];
          const queryParts = query.split('=');

          if (/^rb\_/.test(queryParts[0])) {
            url = url + '&restrictBy[' + queryParts[0].replace(/^rb\_/, '') + ']=' + queryParts[1];
          }
        }

        url = url + '&startIndex=0&maxResults=40&resultsPerPage=40&itemsPerPage=40&items=true&suggestions=true&queryCorrection=true&suggestionsMaxResults=3&pageStartIndex=0&pagesMaxResults=20&categoryStartIndex=0&categoriesMaxResults=20&facets=true&facetsShowUnavailableOptions=false&ResultsTitleStrings=3&ResultsDescriptionStrings=0&page=1&prepareVariantOptions=true';
        
        if (window.themeObj.templates.cms.data.wrapper.attr('data-collection-id')) {
          url = url + '&collection=' + window.themeObj.templates.cms.data.wrapper.attr('data-collection-handle') + '&sortBy=collection_' + window.themeObj.templates.cms.data.wrapper.attr('data-collection-id') + '_position&sortOrder=asc';
        }
        
        return url;
      },
      buildApiLink: function() {
        var uri = window.themeObj.templates.cms.data.uri.split('?')[0];

        const filters = $('.snize-product-filters-block');

        if (filters.length) {

          filters.each(function() {
            const filter = $(this);
            const filterCheckboxes = filter.find('.snize-product-filters-checkbox:checked');

            if (filterCheckboxes.length) {
              const filterQueryName = filter.attr('id').replace(/^snize\_filters\_block\_/, 'rb_');

              if (uri.includes('?')) {
                uri = uri + '&';
              
              } else {
                uri = uri + '?';
              }

              uri = uri + encodeURI(filterQueryName) + '=';
              
              filterCheckboxes.each(function(i2) {
                const filterCheckbox = $(this);
  
                if (i2) {
                  uri = uri + '%7C';
                }
              
                uri = uri + encodeURI(filterCheckbox.attr('value'));
              });
            }
          });
        }

        var sort;

        if ($(window).width() < 1025) {
          sort = $('#snize-modal-mobile-sortby-dialog a.current[data-sort-by][data-sort-order]');
        
        } else {
          sort = $('div.snize-search-results#snize_results .snize-main-panel-dropdown a.current[data-sort-by][data-sort-order]');
        }

        if (sort.length) {
          uri = uri + '&sort_by=' + sort.attr('data-sort-by') + '&sort_order=' + sort.attr('data-sort-order');
        }
        
        window.location.href = uri;
      },
      sorting: function() {
  
          $(document).on('click', 'div.snize div.snize-main-panel-dropdown > a', function() {
            const button = $(this);
            
            const dropdown = button.next('.snize-main-panel-dropdown-content');
            dropdown.toggle();
          });


        
        /* Mobile */

        if (window.themeObj.templates.cms.loaded == 1) {
          $(document).on('click', '#snize_results.snize-mobile-design.snize-new-version div.snize-main-panel-dropdown > a', function() {
            const button = $(this);
            console.log('sort');
  
            if ($(window).width() < 1025) {
              const modal = $('#snize-modal-mobile-sortby-dialog');
              modal.show();
  
            const bg = $('#snize-overlay-mobile-sortby-dialog');
            bg.show();
            }
          });
  
          $(document).on('click', '#snize-modal-mobile-sortby-dialog .snize-close-button', function() {
            const button = $(this);
          console.log('sort');
            
            const modal = button.parent();
            modal.hide();
  
            const bg = $('#snize-overlay-mobile-sortby-dialog');
            bg.hide();
          });
  
          $(document).on('click', '#snize-modal-mobile-sortby-dialog li > a', function() {
            const button = $(this);
            console.log('sort');
  
            const activeButton = button.parents('ul').find('.current');
            activeButton.removeClass('current');
            
            button.addClass('current');
            
            window.themeObj.templates.cms.buildApiLink();
          });
        }
        /* /Mobile */
      },
      filters: function() {
        const mainPanel = $('.snize-main-panel');
        const cmsMainPanel = $('.cms__snize-main-panel');
        mainPanel.html(cmsMainPanel.html());
        
        const filters = $('.snize-product-filters');
        filters.html('').removeClass('snize-hidden');
        
        const mobileFilters = $('#snize_filters_block');

        const response = window.themeObj.templates.cms.data.response;
        const filtersData = response.facets;
                  
        const mobileActiveFilters = $('.snize-selected-filters-container');
        mobileActiveFilters.html('');

        if (filtersData) {
          var selectedFilters = 0;
  
          for (var i = 0; i < filtersData.length; i++) {
            const filterData = filtersData[i];

            if (filterData.title == 'Price') {
              continue;
            }
            
            filters.append(
              '<div id="snize_filters_block_'+ filterData.attribute + '" class="snize-product-filters-block">' +
                '<div class="snize-product-filters-title">' +
                  '<i class="snize-product-filters-close"></i>' +
                  '<i class="snize-product-filters-open"></i>' +
                  '<span>' + filterData.title + ' </span>' +
                '</div>' +
                '<ul class="snize-product-filters-list" style="display: none;"></ul>' +
              '</div>'
            );

            mobileFilters.append(
              '<div data-se-facet-attribute="' + filterData.attribute + '" class="snize-product-filter-opener">' +
                '<span class="snize-product-filter-title">' + filterData.title + '</span>' +
                '<span class="snize-selected-filter-values"></span>' +
              '</div>'
            );

            mobileFilters.after(
              '<div id="snize_product_filter_header_' + filterData.attribute + '" class="snize-product-filters-header" style="display: none;">' +
                '<a href="javascript:void(0);" class="snize-back-to-filters" data-se-facet-attribute="' + filterData.attribute + '">' +
                  '<span class="snize-back-arrow"></span>Filters' +
                '</a>' +
                '<div>' +
                  '<span class="snize-product-filters-title">' + filterData.title + '</span>' +
                '</div>' +
              '</div>' +

              '<div id="snize_product_filter_' + filterData.attribute + '" class="snize-product-filter-container" style="display: none;">' +
                '<ul class="snize-product-filters-list" style="display: block;"></ul>' +
              '</div>'
            );

            const filter = filters.children('.snize-product-filters-block:last');
            const filterTitle = filter.find('.snize-product-filters-title');
            const filterOptions = filter.find('.snize-product-filters-list');
            
            const mobileFilterTitle = mobileFilters.find('.snize-product-filter-opener:last');
            const mobileFilterOptionsHeader = $('#snize_product_filter_header_' + filterData.attribute);
            const mobileFilterOptions = $('#snize_product_filter_' + filterData.attribute + ' .snize-product-filters-list');
            
            const filterBucketsData = filterData.buckets;
  
            if (filterBucketsData) {
              var selectedFilterOptions = 0;
              
              for (var i2 = 0; i2 < filterData.buckets.length; i2++) {
                const filterOption = filterData.buckets[i2];
  
                if (filterOption.selected) {
                  selectedFilterOptions++;
                  
                  if ($(window).width() < 1025) {
                    mobileActiveFilters.append('<span>' + filterOption.value + '<i class="snize-product-filters-reset" data-se-facet-attribute="' + filterData.attribute + '" data-se-facet-value="' + filterOption.value + '"></i></span>');
                  }
                  
                  const mobileFilterTitleValues = mobileFilterTitle.find('.snize-selected-filter-values');
                  mobileFilterTitleValues.append('<span class="snize-selected-filter-value">' + filterOption.value + '</span>');
                }
                
                filterOptions.append(
                  '<li' + (filterOption.selected ? ' class="snize-filter-checked"' : '') + '>' +
                    '<label>' +
                      '<div class="snize-filter-checkbox">' +
                        '<input class="snize-product-filters-checkbox" type="checkbox" name="' + filterData.attribute + '" value="' + filterOption.value + '"' + (filterOption.selected ? ' checked="true"' : '') + '>' +
                        '<span class="needsclick"></span>' +
                      '</div>' +
                      '<span class="needsclick">' +
                        filterOption.value +
                        '<span class="snize-filter-variant-count">' + filterOption.count + '</span>' +
                      '</span>' +
                    '</label>' +
                  '</li>'
                );

                mobileFilterOptions.append(
                  '<li>' +
                    '<label>' +
                      '<div class="snize-filter-checkbox">' +
                        '<input class="snize-product-filters-checkbox" type="checkbox" name="' + filterData.attribute + '" value="' + filterOption.value + '"' + (filterOption.selected ? ' checked="true"' : '') + '>' +
                        '<span class="needsclick"></span>' +
                      '</div>' +
                      '<span class="needsclick">' +
                        filterOption.value +
                        '<span class="snize-filter-variant-count">' + filterOption.count + '</span>' +
                      '</span>' +
                    '</label>' +
                  '</li>'
                );
              }
  
              if (selectedFilterOptions) {
                mobileFilterTitle.append(
                  '<span class="snize-product-filter-count">' + selectedFilterOptions + '</span>' +
                  '<a href="#" data-no-instant="true"><i class="snize-product-filters-reset" data-se-facet-attribute="' + filterData.attribute + '"></i></a>'
                );

                mobileFilterOptionsHeader.find('.snize-product-filters-title').append(
                  '<span class="snize-product-filter-count">' + selectedFilterOptions + '</span>' +
                  '<a href="#" data-no-instant="true"><i class="snize-product-filters-reset" data-se-facet-attribute="' + filterData.attribute + '"></i></a>'
                );

                filterTitle.children('span').append(
                  '<span class="snize-filter-selected-variants-count">' + selectedFilterOptions + '</span> ' +
                  '<a href="javascript:void(0);" data-no-instant="true">' +
                    '<i class="snize-product-filters-reset" data-se-facet-attribute="' + filterData.attribute + '"></i>' +
                  '</a>'
                );

                if (!selectedFilters) {
                  filterTitle.addClass('open');
                  filterOptions.show();
                }
                
                selectedFilters++;
              }
            }
          }
          
          if (selectedFilters) {
            const mobileFiltersLink = $('.snize-main-panel-mobile-filters > a');
            mobileFiltersLink.append('<span class="snize-selected-filters-count-container">' + selectedFilters + '</span>');
            
            const mobileFiltersTitle = $('#snize-modal-mobile-filters-dialog #snize_filters_block_header > .snize-product-filters-title');
            mobileFiltersTitle.append('<span class="snize-product-filters-count">' + selectedFilters + '</span>');
          }
        }

        if (window.themeObj.templates.cms.loaded == 1) {

          $(document).on('click', '#snize_results.snize-mobile-design div.snize-selected-filters-container > span i.snize-product-filters-reset', function() {
            const facetAttribute = $(this).attr('data-se-facet-attribute');

            const desktopClose = $('#snize_filters_block_' + facetAttribute + ' .snize-product-filters-reset');
            console.log('desktopClose', desktopClose.length, facetAttribute);

            if (desktopClose.length) {
              desktopClose.click();
            }
          });

          $(document).on('click', '#snize-modal-mobile-filters-dialog div.snize-product-filter-opener .snize-product-filters-reset', function() {
            const facetAttribute = $(this).attr('data-se-facet-attribute');

            const desktopClose = $('#snize_filters_block_' + facetAttribute + ' .snize-product-filters-reset');
            console.log('desktopClose', desktopClose.length, facetAttribute);

            if (desktopClose.length) {
              desktopClose.click();

              $('#snize-modal-mobile-filters-dialog .snize-modal-mobile-filters-dialog').click();
            }
          });
          
          $(document).on('click', '.snize-product-filters-title', function(e) {
            const timeNow = new Date().getTime();

            if ((window.themeObj.templates.cms.lastClickTime + 100) < timeNow) {
              window.themeObj.templates.cms.lastClickTime = timeNow;
              
              const filterTitle = $(this);
              filterTitle.toggleClass('open');
    
              const filterOptions = filterTitle.next('.snize-product-filters-list');
    
              if (filterTitle.hasClass('open')) {
                filterOptions.show();
    
              } else {
                filterOptions.hide();
              }
            }
          });
  
          $(document).on('click', '.snize-product-filters-reset', function() {
            const resetButton = $(this);
            
            setTimeout(function() {
              const filterTitle = resetButton.parents('.snize-product-filters-title');
              filterTitle.removeClass('open');
  
              const filterOptions = filterTitle.next('.snize-product-filters-list');
              filterOptions.hide();
  
              const filterOptionsCheckboxes = filterOptions.find('.snize-product-filters-checkbox');
    
              filterOptionsCheckboxes.each(function() {
                const filterOptionCheckbox = $(this);
                filterOptionCheckbox.prop('checked', false);
              });
    
              const filterCount = filterTitle.find('.snize-filter-selected-variants-count');
              filterCount.remove();
    
              resetButton.parent().remove();
  
              window.themeObj.templates.cms.buildApiLink();
            }, 100);
          });
  
          $(document).on('click', 'div.snize-search-results#snize_results .snize-main-panel-dropdown ul > li > a', function(e) {
            const currentItem = $('div.snize-search-results#snize_results .snize-main-panel-dropdown a.current');
            currentItem.removeClass('current');
            
            const item = $(this);
            item.addClass('current');
  
            console.log('div.snize-search-results#snize_results .snize-main-panel-dropdown ul > li > a', 'buildApiLink');
            window.themeObj.templates.cms.buildApiLink();
          });
          
          $(document).on('change', '.snize-product-filters-checkbox', function(e) {
            const checkbox = $(this);
            const filter = $('.snize-product-filters-block');
  
            const filterActiveOptions = filter.find('.snize-product-filters-checkbox:checked');
  
            if (!filterActiveOptions.length) {
              filter.find('.snize-product-filters-reset').remove();
              filter.find('.snize-filter-selected-variants-count').remove();
            }
          });
  
          $(document).on('click', 'div.snize ul.snize-product-filters-list li > label', function(e) {
  
            if (e.target.nodeName == 'INPUT') {

              if ($(this).parents('#snize-modal-mobile-filters-dialog').length) {
                const input = $(this).find('input');
                const inputName = input.attr('name');
                const inputValue = input.attr('value');
                
                const desktopInput = $('div.snize .snize-filters-sidebar.snize-product-filters ul.snize-product-filters-list li .snize-filter-checkbox input[type="checkbox"][name="' + inputName + '"][value="' + inputValue + '"]');
  
                if (desktopInput.length) {
                  desktopInput.click();
                }
              
              } else {
                window.themeObj.templates.cms.buildApiLink();
              }
            }
          });
  
          /* Mobile filters */
          const mobileFiltersCount = $('.snize-main-panel-collection-results-found > b');
  
          if (mobileFiltersCount.length) {
            mobileFiltersCount.text(response.totalItems);
          }
           
          const mobileFiltersButtonCount = $('.snize-product-filters-show-products span');
  
          if (mobileFiltersButtonCount.length) {
            mobileFiltersButtonCount.text(response.totalItems);
          }
          
          $(document).on('click', '.snize-main-panel-mobile-filters', function() {
            console.log('snize-main-panel-mobile-filters');
            const overlay = $('#snize-overlay-mobile-filters-dialog');
            overlay.show();
            
            const popup = $('#snize-modal-mobile-filters-dialog');
            popup.show();
  
            popupContent = popup.find('.snize-modal-content');
            popupContent.addClass('snize-filter-opened');
  
            popupContent = popup.find('.snize-modal-content');
            popupContent.removeClass('snize-filter-opened');
            
            $('body').addClass('snize-no-scroll');
          });
          
          $(document).on('click', '#snize-modal-mobile-filters-dialog .snize-close-button, #snize-overlay-mobile-filters-dialog, #snize-modal-mobile-filters-dialog div.snize-product-filters-buttons-container button.snize-product-filters-show-products', function() {
            const overlay = $('#snize-overlay-mobile-filters-dialog');
            overlay.hide();
            
            const popup = $('#snize-modal-mobile-filters-dialog');
            popup.hide();
            
            $('body').removeClass('snize-no-scroll');
          });
          
          $(document).on('click', '.snize-product-filter-opener', function() {
            const filter = $(this);
            const filterId = filter.attr('data-se-facet-attribute');
            const filters = filter.parent();
            filters.hide();
  
            const filterHeader = $('#snize_product_filter_header_' + filterId);
            filterHeader.show();
  
            const filterContent = $('#snize_product_filter_' + filterId);
            filterContent.show();
  
            const popupHeader = $('#snize_filters_block_header');
            popupHeader.hide();
          });
          
          $(document).on('click', '#snize-modal-mobile-filters-dialog .snize-back-to-filters', function() {
            const button = $(this);
            const filter = button.parent();
            filter.hide();
  
            const filterContent = filter.next();
            filterContent.hide();
  
            const filters = $('#snize_filters_block');
            filters.show();
          });
  
          $(document).on('click', '#snize-modal-mobile-filters-dialog div.snize-product-filters-buttons-container button.snize-product-filters-reset-all', function() {
            const button = $(this);
            const buttonLink = window.themeObj.templates.cms.data.uri.replace(/\?.+$/, '');
            window.location.href = buttonLink;
          });
          /* /Mobile filters */
  
          /* Sorting */
          $(document).on('click', '#snize_results.snize-mobile-design.snize-new-version div.snize-main-panel-dropdown > a', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const link = $(this);
          });
          /* /Sorting */
          
          /* Clear all */
          if (selectedFilters) {
            
            if (/\?.+$/.test(window.themeObj.templates.cms.data.uri)) {
              const clearAllButtonLink = window.themeObj.templates.cms.data.uri.replace(/\?.+$/, '');
            
              filters.prepend(
                '<a href="' + clearAllButtonLink + '" class="snize-clear-all-filter">Clear all</a>'
              );
  
              $(document).on('click', '.snize-clear-all-filter', function() {
                window.location.href = this.getAttribute('href');
              });
            }
          }
          /* /Clear all */
        }
      },
      pagination: {
        init: function() {
          var response = window.themeObj.templates.cms.data.response;
          console.log('CMS pagination', 'response', response);
          
          const pagination = $('.snize-pagination');
          
          const header = pagination.find('.snize-search-results-header');
          header.html(
            '<b>' + response.totalItems + '</b> Products'
            // '<b>' + (response.startIndex + 1) + '</b>-<b>' + response.currentItemCount + '</b> of <b>' + response.totalItems + '</b> Products'
          );

          console.log('header', header);

          const mobileHeader = $('.snize-main-panel-collection-results-found');
          header.children('b').text(response.totalItems);
  
          const links = pagination.find('ul');
          links.html('');
  
          const currentPage = 1;
          const totalPages = Math.round(parseFloat(response.totalItems / response.itemsPerPage));
          
          if (totalPages > 1) {
            // header.removeClass('snize-hidden');
            // header.removeClass('header');
  
            if (currentPage == 1 || currentPage == totalPages) {
              links.append(
                '<li>' +
                  '<span class="snize-pagination-prev disabled">«</span>' +
                '</li>'
              );
              
            } else {
              var page = i - 1;
              var paginationLink = window.themeObj.templates.cms.pagination.getPageLink(page);
    
              links.append(
                '<li>' +
                  '<a class="snize-pagination-prev disabled" href="' + paginationLink + '">«</a>' +
                '</li>'
              );
            }

            for (var i = 0; i < totalPages; i++) {
              const page = i + 1;
              
              var paginationLink = window.themeObj.templates.cms.pagination.getPageLink(page);
  
              if (page == totalPages && totalPages > 6) {
                links.append(
                  '<li>' +
                    '<span>...</span>' +
                  '</li>'
                );
              }
              
              links.append(
                '<li>' +
                  '<a href="' + paginationLink + '"' + (page == currentPage ? ' class="active"' : '') + ' rev="' + page + '" data-no-instant="true">' + page + '</a>' +
                '</li>'
              );
            }
            
            if (currentPage == totalPages) {
              links.append(
                '<li>' +
                  '<span class="snize-pagination-next disabled">»</span>' +
                '</li>'
              );
              
            } else {
              var page = currentPage + 1;
              var paginationLink = window.themeObj.templates.cms.pagination.getPageLink(page);
              
              links.append(
                '<li>' +
                  '<a class="snize-pagination-next" href="' + paginationLink + '">»</a>' +
                '</li>'
              );
            }
          }
        },
        getPageLink: function(page) {
          var newLink = window.themeObj.templates.cms.data.uri;

          if (/\?page\=([0-9]+)\&/.test(newLink)) {
            newLink = newLink.replace(/\?page\=([0-9]+)\&/, '?page=' + page + '&');
          
          } else if (/\?/.test(newLink)) {
            newLink = newLink + '&page=' + page;
          
          } else {
            newLink = newLink + '?page=' + page;
          }

          return newLink;
        }
      },
      products: function() {
        const response = window.themeObj.templates.cms.data.response;
        
        const products = $('.snize-search-results-content');
        products.html('');
        const productsData = response.items;
        
        products.prepend('<li id="cms__snize-loaded" style="background: red; width: 300px; height: 300px; display: none !important;"></li>');

        for (var i = 0; i < productsData.length; i++) {
          const productData = productsData[i];
         
          products.append(
            '<li class="snize-product">' +
              '<a href="' + productData.link + '" class="snize-view-link" data-no-instant="true" draggable="false"></a>' +
              
              '<div class="snize-item clearfix snize-top-right-label-showed">' +
                '<a href="' + productData.link + '" class="snize-view-link" data-no-instant="true" draggable="false">' +
                  // '<button class="swym-button swym-add-to-wishlist-view-product product_' + productData.id + ' swym-loaded swym-processed" data-swaction="addToWishlist" data-product-id="' + productData.id + '"data-product-data="{&quot;epi&quot;: 39807835635784, &quot;empi&quot;: 6715217379400, &quot;du&quot;: &quot;https://www.shoehq.com.au/products/rapture-boot-in-bone-smooth-23947&quot;, &quot;dt&quot;: &quot;Rapture Boot in Bone Smooth&quot;, &quot;iu&quot;: &quot;//www.shoehq.com.au/cdn/shop/products/ravella-rapture-boot-in-bone-smooth-23947_1_grande.jpg?v=1675215528&quot;, &quot;pr&quot;: 89}"></button>' +
                '</a>' +
  
                '<div class="snize-thumbnail-wrapper">' +
                  '<a href="' + productData.link + '" class="snize-view-link" data-no-instant="true" draggable="false">' +
                    '<div class="snize-product-label 4545 top-left" style="background: #000000;">' +
                      '<span class="snize-right-arrow" style="border-left-color: #000000; border-right-color: #000000;"></span>Sale' +
                    '</div>' +
                  '</a>' +
                  '<a href="' + productData.link + '" style="display: block">' +
                    '<span class="snize-thumbnail">' + 
                      '<img src="' + productData.shopify_images[0] + '" class="snize-item-image" alt="' + productData.title + '" border="0" loading="lazy">' +
                      '<img src="' + productData.shopify_images[1] + '" class="snize-item-image snize-flip-image" alt="' + productData.title + '" border="0" loading="lazy">' +
                    '</span>' +
                  '</a>' +
                '</div>' +

                '<span class="snize-overhidden">' +
                  '<span class="snize-title" style="max-height: 4.2em; -webkit-line-clamp: 3;">' + productData.title + '</span>' +
                  // '<span class="snize-n-colors">+ 1 colour</span>' +

                  (
                    parseFloat(productData.discount) > 0 ?
                    (
                      parseFloat(productData.discount) <= 25 ?
                      ('<span class="snize-extra-promo" style="color: #ff6700;">' + productData.discount + '% AT CHECKOUT</span>') :
                      ('<span class="snize-extra-promo" style="color: #eb0074;">' + productData.discount + '% OFF AS MARKED LIMITED TIME</span>')
                    )
                   : '') +
            
                  '<span class="snize-attribute">' +
                    '<span class="snize-attribute-title"></span> ' +
                    productData.vendor +
                  '</span>' +
                  '<span class="snize-description snize-hidden"></span>' +
                  '<div class="snize-options-box"></div>' +
                  '<div class="snize-size-select-box teste3445 snize-option-count-' + productData.shopify_variants.length + '"></div>' +
                  
                  '<div class="snize-price-list">' +
                    '<span class="snize-price snize-price-with-discount money">' + window.themeObj.tools.price(productData.price) + '</span>' +
                    (
                      parseFloat(productData.list_price) > 0 ?
                      ('<span class="snize-discounted-price money">' + window.themeObj.tools.price(productData.list_price) + '</span>') :
                      ''
                    ) +
                    '<span class="snize-save-price-wrapper"></span>' +
                  '</div>' +

                  (
                    parseFloat(productData.discount) > 0 ?
                    ('<div class="snize-product-label 0000000 top-left" style="background: #000000; color: #null;">' +
                      '<span class="snize-right-arrow" style="border-left-color: #000000; border-right-color: #000000;"></span>' +
                      'Sale' +
                    '</div>') : ''
                   ) +
                  
                '</span>' +

              '</div>' +
            '</li>'
          );

          const productVariantsData = productData.shopify_variants;

          console.log(productVariantsData);

          if (productVariantsData) {
            const product = products.find('.snize-product:last');
            const productVariants = product.find('.snize-size-select-box');
  
            for (var i2 = 0; i2 < productVariantsData.length; i2++) {
              const productVariantData = productVariantsData[i2];
  
              productVariants.append(
                '<div data-href="' + productVariantData.link + '" class="snize-size' + (!parseInt(productVariantData.available) ? ' snize-size-out-of-stock' : '') + '' + (!i2 ? ' snize-size-active' : '') + '" data-value="' + productVariantData.options[productVariantData.option_size] + '">' + productVariantData.options[productVariantData.option_size] + '</div>'
              );
            }
          }
        }
      }
    }
  },
  sections: {}
};

$(document).ready(function() {
  window.themeObj.init();
});